import { Card } from "./ui/card";
import { cn } from "../lib/utils";

export function MetricCard({ label, value, sub, icon, variant = "default", testid, className, onClick }) {
  const variants = {
    default: "bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700 text-slate-900 dark:text-slate-100",
    dark: "bg-slate-900 text-white border-transparent",
    accent: "bg-emerald-50 dark:bg-emerald-950/40 border-emerald-100 dark:border-emerald-900 text-slate-900 dark:text-emerald-100",
  };
  const labelColor =
    variant === "dark" ? "text-slate-300" : "text-slate-500 dark:text-slate-400";
  return (
    <Card
      data-testid={testid}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      className={cn(
        "rounded-2xl border p-5 shadow-sm transition-all hover:shadow-md",
        onClick && "cursor-pointer",
        variants[variant],
        className
      )}
    >
      <div className="flex items-start justify-between gap-3">
        <div className={cn("text-[11px] uppercase tracking-[0.14em] font-semibold", labelColor)}>
          {label}
        </div>
        {icon && (
          <div
            className={cn(
              "h-9 w-9 rounded-full flex items-center justify-center",
              variant === "dark"
                ? "bg-white/10 text-emerald-300"
                : "bg-emerald-50 dark:bg-emerald-950/40 text-emerald-700 dark:text-emerald-300"
            )}
          >
            {icon}
          </div>
        )}
      </div>
      <div className="font-mono-num text-3xl sm:text-4xl font-medium mt-2 leading-tight">
        {value}
      </div>
      {sub && <div className={cn("text-sm mt-1", variant === "dark" ? "text-slate-400" : "text-slate-500 dark:text-slate-400")}>{sub}</div>}
    </Card>
  );
}
